export default __webpack_public_path__ + "static/media/felix.ba5f6235.png";